export interface IPoolStudioSettingsGroup {
    ID: number;
    Name: string;
    IsDefault: boolean;
    IsDev: boolean;

}

export class PoolStudioSettingsGroupArray extends Array<PoolStudioSettingsGroup>  {

    constructor(...items: PoolStudioSettingsGroup[]) {
        super(...items);
        Object.setPrototypeOf(this, PoolStudioSettingsGroup.prototype);
    }

}

export class PoolStudioSettingsGroup implements IPoolStudioSettingsGroup {
    ID: number;
    Name: string;
    IsDefault: boolean;
    IsDev: boolean;
}
